module.exports = __webpack_public_path__ + "media/map/CA_Icon-694bac51.png";